<template>
  <!-- A text link that opens one of the long-form authoring guides
       (atlasWorkflowHelp.js HELP_GUIDES) in a scrollable dialog — for
       content too big for a HelpTip card. -->
  <span v-if="g">
    <a class="text-caption text-decoration-underline" @click.prevent="open = true">
      {{ linkText || g.title }}
    </a>
    <v-dialog v-model="open" max-width="720" scrollable>
      <v-card>
        <!-- d-flex explicitly: the portal theme un-flexes v-card__title,
             so a v-spacer alone never pushes the close button right. -->
        <v-card-title class="text-subtitle-1 py-2 d-flex justify-space-between align-center flex-nowrap">
          <span>{{ g.title }}</span>
          <v-btn icon @click="open = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text style="max-height: 70vh">
          <p v-if="g.intro" class="text-body-2 mt-2">{{ g.intro }}</p>
          <template v-for="(s, i) in g.sections">
            <div :key="`h${i}`" class="text-subtitle-2 mt-3 mb-1">{{ s.heading }}</div>
            <p v-if="s.body" :key="`b${i}`" class="text-body-2 mb-1">{{ s.body }}</p>
            <ul v-if="s.bullets" :key="`u${i}`" class="text-body-2 pl-4">
              <li v-for="(b, j) in s.bullets" :key="j" class="mb-1">{{ b }}</li>
            </ul>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import { HELP_GUIDES } from './atlasWorkflowHelp';

export default {
  name: 'HelpGuideDialog',
  props: {
    guide: { type: String, required: true },
    linkText: { type: String, default: '' },
  },
  data() {
    return { open: false };
  },
  computed: {
    g() {
      return HELP_GUIDES[this.guide] || null;
    },
  },
};
</script>
